module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-e3f540ea.png";